<template>
  <div>
    <case-procedure-card
      :info-item="procedure"
      :icon="'mdi-archive'"
      :header="procedure.procedureRef"
      :code-display-name="local.caseFile.cards.procedure.codeDisplayName"
      :code="procedure.requestCode"
      :status="procedure.status"
      :status-id="procedure.statusId"
      :status-display-name="local.caseFile.cards.procedure.statusDisplayName"
      :date="procedure.procedureDate"
      :date-display-name="local.caseFile.cards.procedure.dateDisplayName"
      :has-actions="true"
      :court-name="procedure.courtName"
      :sub-circle-name="procedure.subCircleName"
      :period="period"
      @card-click="getView(procedure)"
    >
    </case-procedure-card>

    <naj-confirmation
      :show-modal="requestInCompleteReasonsModal"
      :max-width="750"
      :is-persistent="false"
      :title="local.common.inCompleteReasons"
      :close-btn-label="local.common.close"
      @cancel="hideRequestInCompleteReasons"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <naj-alert type="information">
              <template
                v-if="procedure"
                slot="content"
              >
                <span v-if="procedure.notes"> {{ procedure.notes }}</span>
                <span v-else> {{ local.common.noReasonsToDisplay }} </span>
              </template>
            </naj-alert>
          </v-col>
        </v-row>
      </template>
    </naj-confirmation>
  </div>
</template>

<script>
import { toHijriDate, getTimePart } from '@/helpers/utils';
import CaseProcedureCard from './case-procedure-card.vue';
import { requestStatus } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';

const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
export default {
  name: 'ProcedureCard',
  components: { CaseProcedureCard },
  props: {
    procedure: {
      type: Object,
      required: true,
    },
    isPega: {
      type: [String, Boolean],
      required: true,
    },
    period: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      requestStatus,
      requestInCompleteReasonsModal: false,
      socialId: null,
    };
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    toHijriDate,
    getTimePart,
    getView(item) {
      this.$router.push({ path: `/cases/case-related-procedure/non-specialty-procedure/${this.procedure.procedureObjectKey}?isPega=true` });
    },
    showRequestInCompleteReasons() {
      this.requestInCompleteReasonsModal = true;
    },
    hideRequestInCompleteReasons() {
      this.requestInCompleteReasonsModal = false;
    },
  },
};

</script>
<style scoped>
.header-text {
  font-size: 18px;
}

::v-deep .case-update-card-header {
  color: var(--app-dark-primary-color);
  font-size: 25px;
}
</style>
